

import { DataGrid } from "components/DataGrid/DataGrid";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useState } from "react";
import { downloadCSV, getPageSize, trans } from "utils/helpers";

import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { Toast } from "components/ToastShow/ToastAlert";
import { getAllItemProperties } from "./api";
import { ItemPropertiesForm } from "./ItemPropertiesForm";
import { Button } from "components/Button/Button";
import { MessageType } from "types/enum";

interface Form {
    onHide: () => void;
    PropertiesListcallback: (list) => void;
    formRefs?:any;

}
export const ItemPropertiesList = ({ onHide ,PropertiesListcallback}: Form) => {


    const [response, setResponse] = useState<Response | any>(null);
    const [selectedObj, setSelectedObj] = useState< any>(null);
    const [mode, setMode] = useState("create");
    const [forceUpdate, setForceUpdate] = useState(false);
    const [resetForm, setResetForm] = useState(false);
    const [editForm, setEditForm] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [formLoading,setFormLoading] = useState(false);
    const [messageType, setMessageType] = useState<any>("info");
    const [orderBy, setOrderBy] = useState<any>([]);
    const [search, setSearch] = useState(null);
    const [propertyType, setPropertyType] = useState(1);
    const [showForm, setShowForm] = useState(false);
    const [title, setTitle] = useState<any>();
    const [keyWords, setKeyWords] = useState<any>([]);
    const [pageNum, setPageNum] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [filterlist, setFilterlist] = useState<any>("");
    const [fromDate, setFromDate] = useState<any>(null);
    const [pages, setPages] = useState<number>(0);
    const [userChanges, setUserChanges] = useState({});
    const [selectList , setSelectList] = useState<any>()



    const handleChangePageSize = (e: any) => {
        setPageNum(1);
        setPageSize(e.currentTarget.value);
        getPageSize("ItemPropertiesList" ,e.currentTarget.value )
        getAllItemPropertiesAsync(1)
      };


      function handleGoPage(value): void {
        if (value) {
            if (value < 1 || value > pages) { }
            else {setPageNum(+value);getAllItemPropertiesAsync(+value)}
        } else {
        }
    }
    
    const handleNextPage = () => {
        if(pageNum < pages){
            setPageNum(pageNum + 1);
            getAllItemPropertiesAsync(pageNum + 1);
          };
    };
    const handlePrevPage = () => {
        if(pageNum > 1){
            setPageNum((pageNum)=>{return +pageNum - 1});
            getAllItemPropertiesAsync(pageNum - 1);
          };
    };

    const searchHandler = (str) => {
        setPageNum(1);
        if(str =="" ){
            setSearch(null)
        }else{
            setSearch(str)
        }
      }



    const selectedIdCallback = (obj, index) => {
        if(sessionStorage.getItem("changingforms")+""=="true"){
            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{setSelectedObj(obj);sessionStorage.setItem("changingforms" , "false"); setUserChanges({}) });
            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{setSelectedObj(obj);sessionStorage.setItem("changingforms" , "false"); setUserChanges({}) });

        }else{
            setSelectedObj(obj)         
        };
    }


    // const handleDeleteRow = async() => {
    //     try {
            // const res = await deleteItemProperties(selectedObj.Id)
    //         setForceUpdate(!forceUpdate)
    //     } catch (error) {
            
    //     }
    // }


    async function getAllItemPropertiesAsync(PageNum =pageNum) {
        setLoading(false)
        let pageSizeChangedByUser = getPageSize("ItemPropertiesList" )
        setPageSize(pageSizeChangedByUser)
        try {
            const res = await getAllItemProperties(PageNum,  pageSizeChangedByUser  ,search ,orderBy.length == 0 ?null:  orderBy.join(",") ,filterlist);
            setResponse(res.Data);
            setPages(res.Data.TotalRecords > pageSizeChangedByUser ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser) : 1) 
            setMessageType("info")
        } catch (error) {
            setMessageType("error")
        }
        setLoading(true)
    }


    const handleCreateAction = () => {

        setEditForm(null)
        setMode("create")
        setShowForm(true)

    }

    const selectListCallBack =(list)=>{
          
        setSelectList(list[1])
      }

    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
      };

      const makePropertiesList = (event) => {
        if(selectList != undefined){

            event.preventDefault();    
            PropertiesListcallback([...selectList])
            onHide()
        }else{
        }
    }

    function cancel() {
        if(sessionStorage.getItem("changingforms")+""=="true"){
            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
            //     sessionStorage.setItem("changingforms" , "false");
            //     setUserChanges({});
            //     onHide()
            // });
            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                sessionStorage.setItem("changingforms" , "false");
                setUserChanges({});
                onHide()
            });
        }else{
            onHide()    
        };

    }

    useEffect(() => {
        if(Object.values(userChanges).filter((item)=>item!=null).length>0){

            sessionStorage.setItem("changingforms" , "true")
              window.addEventListener('beforeunload', handleBeforeUnload);
              return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
              };
        }else{
            sessionStorage.setItem("changingforms" , "false")
            window.removeEventListener('beforeunload', handleBeforeUnload);

        }
    }, [userChanges]);

    useEffect(() => {
        getAllItemPropertiesAsync();
    }, [forceUpdate ,search , orderBy , filterlist , pageNum]);

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
            getAllItemPropertiesAsync();
        }
    }, [resetForm]);
    useEffect(() => {
        if(showForm &&selectedObj && mode != "create"){
            setEditForm(null);
           
        }else{
            if(showForm) setFormLoading(true)
        }
       
    }, [selectedObj ,showForm]);





    /* #endregion */

    /* #region toolbarActions */
    const clickToolbarCallback = (clickedButtonName: string) => {
        switch (clickedButtonName.toLowerCase()) {
            case "print": alert("print "); break;
            case "excel":downloadCSV(response?.Data ,1 ,trans("ItemPropertiesList"));break;
            case "refresh": setForceUpdate(!forceUpdate); break;
            case "help": alert("call api help"); break;
            case "create": handleCreateAction(); break;
            // case "remove": if (selectedObj?.Id)Toast(trans("msg_deleteconfirm"), "warning" , "alert" , handleDeleteRow); break;


        }
    };
    /* #endregion */


    return (
        <>
            <div className="cartable-action">

                <Toolbar warehouse={false} handleSearch={searchHandler} view={false} remove={false}  id={selectedObj?.Id} emptyList={response?.Data?.length == 0} create={true} edit={false} search={true} handleClickToolbar={clickToolbarCallback} />
                <div className="card" style={{overflowY: "auto",
             height: "74vh",
            scrollbarWidth: "thin",}}>
                    <div className="">
                            <>
                                {showForm&& 
                                <>
                                <ItemPropertiesForm reload={()=>{setForceUpdate(!forceUpdate)}} onHide={()=>{setShowForm(false)}} />
                                   </>
                                }
                                {loading ?
                                    response?.Data?.length > 0 ?
                                        <>
                                            <DataGrid
                                                 selectItem={(e) => {   }}
                                                 multiSelect={true}
                                                 selectList={selectListCallBack}
                                                parentName={"ItemPropertiesList"}
                                                handlefiltering={(str)=>{setFilterlist(str)  }}
                                                filterStr={filterlist}
                                                orderFormat={setOrderBy}
                                                orderFormatList={orderBy}
                                                startIndex={1}
                                                theadData={Object.keys(response.Data[0])}
                                                tbodyData={response.Data}
                                                minCellWidth={80}
                                                selectedRowObjectCallback={selectedIdCallback}
                                                totalRecords={response.TotalRecords}
                                                pageNum={pageNum}
                                                pageSize={pageSize}
                                                HandleNextPage={handleNextPage}
                                                HandlePrevPage={handlePrevPage}
                                                // handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), "warning" , "alert" ,handleDeleteRow)}}
                                                handlechangePageSize={handleChangePageSize}
                                                first={() =>{getAllItemPropertiesAsync(pages); setPageNum(pages)}}
                                                end={() =>{getAllItemPropertiesAsync(1); setPageNum(1)}}
                                                handleGoPage={handleGoPage}
                                            />
                                        </>
                                        : <Message message={"NoDataForPreview"} type={messageType} />
                                        :<Loading/>
                                }
                                        {  mode !="view"?
                                              <div className="col-lg-12 mt-1 btns_form">
                                              <Button onClick={makePropertiesList} value="Save" btnType="submit" />
                                              <Button btnType="cancel" value="Cancel" onClick={cancel} />
                                              </div>
                                              :
                                              <div className="col-lg-12 mt-1 btns_form">
                                              <Button btnType="primary" value="close" onClick={cancel} />
                                              </div>

                                          }   
                            </>
                    </div>
                </div>
            </div>
        </>

    );
}